class ProductQuiz extends HTMLElement {
  constructor() {
    super();
    this.bodyEl = document.querySelector('body');
    this.quizStartBtn = this.querySelector('.quiz__button');
    this.bannerContainer = this.querySelector('.quiz__video-wrapper');
    this.quizPopupWrapper = this.querySelector(".quiz__popup-wrapper");
    this.quizPopupOverlay = this.querySelector(".quiz__popup-overlay");
    this.quizCloseBtn = this.querySelector(".quiz__close-btn");
    this.quizForm = this.querySelector('.quiz__form');
    this.steps = Array.from(this.querySelectorAll('.quiz__step'));
    this.resultContainer = this.querySelector('.quiz__result');
    this.backBtn = this.querySelector('.quiz__back-btn');
    this.restartBtn = this.querySelector('.quiz__restart-btn');
    this.progressFill = this.querySelector('.quiz__progress-fill');
    this.personaScreen = this.querySelector('.quiz__persona');
    this.personaNextBtn = this.querySelector('.quiz__persona-next-btn');
    this.progressSteps = this.querySelector(".quiz__progress-steps");
    this.progressDone = this.querySelector(".quiz__progress-completes");
    this.cartValue = this.dataset.cartValue;
    this.customerType = this.dataset.customerType;

    this.currentStep = 0;
    this.answers = {};
    this.totalSteps = this.steps.length;
    this.stepTimeout = null;
    this.personaSuggestion = "";

    this.fragranceOptions = {
      Him: [
        { label: 'Fresh & Aquatic', value: 'Magnetic' },
        { label: 'Musky Oud', value: '007' },
        { label: 'Fresh & Citrusy', value: 'Fierce' },
        { label: 'Woody Fresh', value: 'Slow Kiss' },
        { label: 'Coffee & Amber', value: 'Midnight in bombay' },
      ],
      Her: [
        { label: 'Fruity & Sweet', value: 'Cherry wine' },
        { label: 'Warm Vanilla', value: 'Vanila muse' },
        { label: 'Floral & Sweet', value: 'Bite of desire' },
        { label: 'Coffee & Amber', value: 'Midnight in bombay' }
      ]
    };

    this.styleOptions = {
      Him: [
        { label: 'A well-fitted blazer with sneakers' },
        { label: 'Comfy Pyjamas' },
      ],
      Her: [
        { label: 'A classic black dress and heels', value: 'Cherry wine' },
        { label: 'A linen kurta with silver jewelry' },
        { label: 'Comfy Pyjamas' },
      ]
    };


    this.bindEvents();
    this.showStep(this.currentStep);
    this.hideBanners()
  }

  bindEvents = () => {
    this.quizStartBtn?.addEventListener('click', () => {
      this.startQuiz();
    });

    this.bannerContainer.addEventListener('click', () => {
      this.startQuiz();
    })

    this.quizCloseBtn?.addEventListener('click', this.closePopup);
    this.quizPopupOverlay?.addEventListener('click', (event) => {
      if (event.target.classList.contains("quiz__popup-overlay")) {
        this.closePopup();
      }
    });

    this.restartBtn?.addEventListener('click', () => {
      this.quizForm.reset();
      this.resetQuiz();
    })

    this.personaNextBtn?.addEventListener('click', () => {
      this.showResults();
    });


    this.steps.forEach((step, index) => {
      const inputs = step.querySelectorAll('input');

      inputs.forEach(input => {
        input.addEventListener('click', (e) => {
          clearTimeout(this.stepTimeout);
          const question = input.dataset.question;
          this.answers[question] = input.value;

          if (index === 0) {
            this.updateFragranceOptions(input.value); // Trigger fragrance options update
            this.updateStyleOptions(input.value);
          } 
          this.stepTimeout = setTimeout(() => {
            this.nextStep();
          }, 1000);

          const clevertapData = {
            Question_step : question,
            Answer : input.value
          }

          dataLayer.push({
            event: "Question",
            Question_step : question,
            Answer : input.value,
            clevertap: clevertapData
          });
        });
      });

    });

    // this.backBtn?.addEventListener('click', () => {
    //   clearTimeout(this.stepTimeout);

    //   if (this.currentStep > 0) {
    //     this.currentStep--;
    //     this.showStep(this.currentStep, true);
    //   }
    // });

    this.backBtn?.addEventListener('click', () => {
      clearTimeout(this.stepTimeout);

      let prevStep = this.currentStep - 1;

      // Skip over greeting steps
      while (prevStep >= 0 && this.steps[prevStep].dataset.greeting === "true") {
        prevStep--;
      }

      if (prevStep >= 0) {
        this.currentStep = prevStep;
        this.showStep(this.currentStep, true);
      }
    });
  }

  startQuiz = () => {
    this.bodyEl?.classList.add('no-scroll');
    this.quizPopupWrapper?.classList.remove('hidden');

    const clevertapData = {
      Current_Cart_Value : this.cartValue,
      Customer_Type : this.customerType
    }

    dataLayer.push({
      event: "Quiz_Start",
      Current_Cart_Value : this.cartValue,
      Customer_Type : this.customerType,
      clevertap: clevertapData
    });
  }

  closePopup = () => {
    this.quizPopupWrapper?.classList.add('hidden');
    this.quizForm.reset();
    this.resetQuiz();
  }

  showStep = (index, goingBack = false) => {
    this.steps.forEach(step => {
      step.classList.remove('active', 'backward');
      step.classList.add('hidden');
    });

    const current = this.steps[index];
    if (!current) return;

    current.classList.remove('hidden');
    requestAnimationFrame(() => {
      current.classList.add('active');
      if (goingBack) current.classList.add('backward');
    });

    this.updateProgress(index);

    const isGreeting = current.dataset.greeting === "true";
    if (isGreeting) {
      clearTimeout(this.stepTimeout); // Clear previous timer just in case
      if (!goingBack) {
        this.stepTimeout = setTimeout(() => this.nextStep(), 2000);
      }
    }

    this.resultContainer?.classList.add('hidden');
  }

  nextStep = () => {
    this.currentStep++;
    if (this.currentStep >= this.steps.length) {
      this.fetchResults();
    } else {
      
      this.showStep(this.currentStep);
    }
  }

  fetchResults = () => {

    const formattedAnswers = Object.entries(this.answers).map(([question, answer]) => ({
      question,
      answer
    }));

    const personaObject = {
      "The Hustler": "You're juggling 3 side gigs one big dream—fuelled by coffee, ambition, and sheer jugaad.",
      "The Old Soul": "You sip adrak wali chai while listening to Kishore Kumar on a rainy afternoon.",
      "The Soft One": "You are delicate, dreamy and and still believe in soulmates.",
      "The Main Character": " You are bold, a little mysterious, and totally unapologetic."
    }

    const payload = `data=${encodeURIComponent(JSON.stringify(formattedAnswers))}`;

    try {
      fetch('https://script.google.com/macros/s/AKfycbxTr_NEo8m1ZGY5sWQzLpgKJLH-UOjCFXuzXl-fGtOMAjzhLCaXJb2F9vUyxvETUDr7hw/exec', {
        method: 'POST',
        body: payload, // array of {question, answer}
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
      .then(res => res.json())
      .then(data => {
        const suggestion = data.matches[0][3];
        const description = personaObject[suggestion];
        this.showPersonaScreen(suggestion, description);
      });

    } catch (error) {
      console.log(error);
    }
  }

  showPersonaScreen = (suggestion, description) => {
    this.steps.forEach(step => {
      step.classList.remove('active');
      step.classList.add('hidden');
    });

    this.resultContainer?.classList.add('hidden');
    this.personaScreen?.classList.remove('hidden');
    requestAnimationFrame(() => {
      this.personaScreen?.classList.add('active');
    });

    this.personaSuggestion = suggestion;

    this.personaScreen.innerHTML = `
      <div class="quiz__persona-inner">
        <h4>YOUR FRAGRANCE PERSONALITY IS DECODED!</h4>
        <h2>${suggestion}</h2>
        <p class="quiz__persona-description">
          ${description}
        </p>
        <button class="quiz__persona-next-btn">Reveal my perfume</button>
      </div>
    `
    this.backBtn?.classList.add('hidden');

    const nextBtn = this.personaScreen.querySelector('.quiz__persona-next-btn');
    nextBtn?.addEventListener('click', () => {
      this.showResults();
    });
  }

  updateFragranceOptions = (gender) => {
    const nonGreetingSteps = Array.from(this.steps).filter(
      (step) => step.dataset.greeting !== 'true'
    );

    const step5 = nonGreetingSteps[4]; // 5th step (index starts from 0)
    const allInputs = step5.querySelectorAll('input');
    const allLabels = step5.querySelectorAll('label');

    const allowed = this.fragranceOptions[gender]?.map(opt => opt.label) || [];

    const listElArray = []
    allInputs.forEach(input => {
      const shouldShow = allowed.includes(input.value);
      const listEl = input.closest('li');
      listEl.style.display = shouldShow ? 'block' : 'none';
      if (shouldShow) {
        listElArray.push(listEl);
      }
    });

    if (listElArray.length > 0) {
      listElArray[0].classList.add('first-option');
      listElArray[listElArray.length - 1].classList.add('last-option')
    }

    // Optionally, reset selection if it’s not in allowed list
    allInputs.forEach(input => {
      if (!allowed.includes(input.value)) {
        input.checked = false;
      }
    });
  };

  updateStyleOptions = (gender) => {
    const nonGreetingSteps = Array.from(this.steps).filter(
      (step) => step.dataset.greeting !== 'true'
    );

    const step4 = nonGreetingSteps[3]; // 4th step (index starts from 0)
    const allInputs = step4.querySelectorAll('input');

    const allowed = this.styleOptions[gender]?.map(opt => opt.label) || [];

    const listElArray = []
    allInputs.forEach(input => {
      const shouldShow = allowed.includes(input.value);
      const listEl = input.closest('li');
      listEl.style.display = shouldShow ? 'block' : 'none';
      if (shouldShow) {
        listElArray.push(listEl);
      }
    });

    if (listElArray.length > 0) {
      listElArray[0].classList.add('first-option');
      listElArray[listElArray.length - 1].classList.add('last-option')
    }

    // Optionally, reset selection if it’s not in allowed list
    allInputs.forEach(input => {
      if (!allowed.includes(input.value)) {
        input.checked = false;
      }
    });
  }


  updateProgress(stepIndex) {
    const currentEl = this.querySelector('.quiz__progress-current');
    const totalEl = this.querySelector('.quiz__progress-total');
    const progressFill = this.querySelector('.quiz__progress-fill');

    const steps = this.querySelectorAll('.quiz__step');

    const originalSteps = Array.from(steps)

    const totalQuestions = originalSteps.length;
    const currentStep = originalSteps.findIndex(
      (step) => stepIndex === (parseInt(step.dataset.step) - 1 )
    );

    if (currentStep >= 0 ) {
      if (currentEl) currentEl.textContent = currentStep;
      if (totalEl) totalEl.textContent = (totalQuestions - 1);
  
      const percentage = (currentStep / (totalQuestions - 1)) * 100;
      if (progressFill) progressFill.style.width = `${percentage}%`;
    }
  }

  fetchProductDetails = async () => {
    this.progressSteps.classList.add('hidden');
    this.progressDone.classList.remove('hidden');
    
    const productsList = this.resultContainer.querySelectorAll(".quiz__suggested-product");

    const answers = Object.entries(this.answers).map(([question, answer]) => ({
      question,
      answer
    }));

    const combinationText = `${answers[0].answer} | ${answers[4].answer}`;
    productsList.forEach((product) => {
      if (product.dataset.combination === combinationText) {
        product.classList.remove('hidden');

        const clevertapData = {
          Product_suggested : product.dataset.productTitle,
          Personality_type : this.personaSuggestion
        }

        dataLayer.push({
          event: "Quiz_Complete",
          Product_suggested : product.dataset.productTitle,
          Personality_type : this.personaSuggestion,
          clevertap: clevertapData
        });
      }
      else {
        product.classList.add('hidden');
      }
    })
  }

  showResults = () => {
    this.steps.forEach(step => {
      step.classList.remove('active');
      step.classList.add('hidden');
    });

    this.personaScreen?.classList.add('hidden');
    this.personaScreen?.classList.remove('active');
    
    this.fetchProductDetails();
    this.backBtn.classList.add('hidden');
    this.resultContainer.classList.remove('hidden');
    this.updateProgress(this.totalSteps);
  }

  resetQuiz = () => {
    this.progressSteps.classList.remove('hidden');
    this.progressDone.classList.add('hidden');
    this.currentStep = 0;
    this.answers = {};
    this.updateProgress(0);
    this.showStep(this.currentStep);
    this.resultContainer?.classList.add('hidden');
    this.personaScreen?.classList.add('hidden');
    this.personaScreen?.classList.remove('active');
    this.backBtn?.classList.remove('hidden');
    this.bodyEl?.classList.remove('no-scroll');
  }

  hideBanners = () => {
    this.querySelectorAll('.splide__slide.quiz__video-wrapper').forEach(slide => {
      const videoWrapper = slide.querySelector('.quiz__banner-video-wrapper');
      const poster = slide.querySelector('.quiz__poster-image');
      const videos = slide.querySelectorAll('video');
      if (videos.length > 0 && poster) {
        videos.forEach(video => {
          const showVideo = () => {
            poster?.classList.add('hidden');
          };
    
          setTimeout(() => {
            showVideo();
          }, 1000);
    
          // Fallback for videos that are already ready (e.g. on Safari)
          if (video.readyState >= 3 && !video.paused) {
            setTimeout(() => {
              showVideo();
            }, 1000);
          }
        });
      }
      else {
        poster?.classList.remove('poster__absolute');
      }
    });
  }
}

customElements.define('product-quiz', ProductQuiz);

document.querySelectorAll('.splide__slide.quiz__video-wrapper').forEach(slide => {
  slide.addEventListener('click', () => {
    document.querySelector('product-quiz').startQuiz();
  });
});
